'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_FLASH = exports.SET_FLASH = undefined;

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

exports.setFlash = setFlash;
exports.clearFlash = clearFlash;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_FLASH = exports.SET_FLASH = (0, _symbol2.default)('SET_FLASH');
var CLEAR_FLASH = exports.CLEAR_FLASH = (0, _symbol2.default)('CLEAR_FLASH');

function setFlash() {
  var flash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return { type: SET_FLASH, flash: flash };
}

function clearFlash() {
  return { type: CLEAR_FLASH };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/flash.js
// module id = 176
// module chunks = 0